import React from "react";
import { Link } from "react-router-dom";
import "./Sidebar.css";
import { MdOutlineDashboard, MdOutlineCollectionsBookmark, MdOutlinePayment, MdOutlineEvent, MdOutlineContactMail,MdLogout } from 'react-icons/md';


const Sidebar = ({handleLogout}) => {
  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h2>Admin Dashboard</h2>
      </div>
      <ul>
        <li>
          <Link to="/admin/dashboard/blog">
            <MdOutlineDashboard /> 
            <span className="link-text">Blog</span> 
          </Link>
        </li>
        <li>
          <Link to="/admin/dashboard/gallery">
            <MdOutlineCollectionsBookmark /> 
            <span className="link-text">Gallery</span> 
          </Link>
        </li>
        <li>
          <Link to="/admin/dashboard/videos">
            <MdOutlineCollectionsBookmark /> 
            <span className="link-text">Videos</span> 
          </Link>
        </li>
        <li>
          <Link to="/admin/dashboard/donation">
            <MdOutlinePayment /> 
            <span className="link-text">Payments</span> 
          </Link>
        </li>
        <li>
          <Link to="/admin/dashboard/event">
            <MdOutlineEvent /> 
            <span className="link-text">Events</span> 
          </Link>
        </li>
        <li>
          <Link to="/admin/dashboard/contact" >
            <MdOutlineContactMail /> 
            <span className="link-text " >Contact</span> 
          </Link>
        </li>
        <li>
        {/* className="logout-button" */}
          <Link onClick={handleLogout} >
          <MdLogout className="logout-btn" /> 
           <span className="link-text logout-btn">LogOut</span> 
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;